const getTextWithHighlight = (
  search: string,
  text: string,
  isPrefix = true,
) => {
  const prefix = isPrefix ? search[0] : ''
  const partHashText = search.slice(1)

  const textLowercase = text.toLowerCase()
  const partHashLowercase = partHashText.toLowerCase()

  const startSearchIndex = textLowercase.indexOf(partHashLowercase)

  if (!partHashText || startSearchIndex === -1) return text

  const isStartOfWord = textLowercase.startsWith(partHashLowercase)

  const startText = `${isStartOfWord ? '' : prefix}${text.slice(0, startSearchIndex)}`

  const selectedText = text.slice(
    startSearchIndex,
    startSearchIndex + partHashText.length,
  )
  const highlightedText = selectedText
    ? `<span class="text-blue-500">${isStartOfWord ? prefix : ''}${selectedText}</span>`
    : ''
  const endText = `${text.slice(startSearchIndex + partHashText.length)}`

  const result = `${startText}${highlightedText}${endText}`

  return result
}

export default getTextWithHighlight
